import React from "react";

const ParcelInfoModal = ({ parcel, goToLoteamiento, hideModal }) => {
  const city = parcel?.properties?.developments?.features[0]?.properties?.district?.name || ''
  const department = parcel?.properties?.developments?.features[0]?.properties?.district?.department?.name || ''
  const availableParcels = parcel?.properties?.developments?.features[0]?.properties?.available_parcels || 0
  return (
    <div className="modal shadow1 info-modal" onPointerLeave={() => {
      hideModal();
    }}>
      <div className={`modal-header darkgrayBackground whiteColor textCentered`}>
        <div className="modal-title textCentered" style={{ width: '100%' }}>{parcel.properties.name}</div>
      </div>
      <div className="modal-body">
        <div className="modal-data">
          <span className="weight600">Ciudad:</span>
          <span>{city}</span>
        </div>
        <div className="modal-data">
          <span className="weight600">Departamento:</span>
          <span>{department}</span>
        </div>
        <div className="modal-data">
          <span className="weight600">Lotes disponibles:</span>
          <span>{availableParcels}</span>
        </div>
        <div style={{ textAlign: "center" }}>
          <button className="home-filters-button"
            onClick={() => goToLoteamiento(parcel)}
          >Ver en el mapa</button>
        </div>
      </div>
    </div>
  )
};

export default ParcelInfoModal;

